import { t } from '@lingui/core/macro'
import orderBy from 'lodash/orderBy'

export function sortPieSlices(data) {
  const otherLabel = t`Other`

  // set "Other" as last slice by assigning a weight to it
  const nameWeight = (item) => {
    return item.name === otherLabel ? 1 : 0
  }

  // sort by name weight asc, then value desc and then name asc
  return orderBy(data, [nameWeight, 'value', 'name'], ['asc', 'desc', 'asc'])
}
